/** The narrowest a column gets, at zoom 1, however it is sized. */
export const MIN_COLUMN_WIDTH = 40;

/**
 * A column's width at zoom 1: the width the user dragged it to, else, with
 * columns expanded, wide enough for both its content estimate and its header
 * as measured, else the file's (or the estimate's) fitted width.
 */
export function columnWidth({
  manual,
  expanded,
  base,
  expandedEstimate,
  headerFit,
}: {
  manual: number | undefined;
  expanded: boolean;
  base: number;
  expandedEstimate: number;
  headerFit: number | undefined;
}): number {
  if (manual !== undefined) return Math.max(MIN_COLUMN_WIDTH, manual);
  if (!expanded) return base;
  return Math.max(expandedEstimate, headerFit ?? 0);
}
